const BandCampIframes = [
  {
    url:"https://bandcamp.com/EmbeddedPlayer/album=440112989/size=large/bgcol=333333/linkcol=ffffff/transparent=true/",
    link: "https://pruflaborsonor.bandcamp.com/album/hell-bots",
    label: "Hell-ô bots by Prüflabor Sonor",
    release: "2021-08-28",
    style: {
      width: "350px",
      height: "621px",
      border: "0"
    }
  },
  {
    url:"https://bandcamp.com/EmbeddedPlayer/album=3583746637/size=large/bgcol=333333/linkcol=ffffff/transparent=true/",
    link: "https://pruflaborsonor.bandcamp.com/album/vanila-soup",
    label: "Vanila Soup by Prüflabor Sonor",
    release: "2020-12-27",
    style: {
      width: "350px",
      height: "687px",
      border: "0"
    }
  },
  {
    url: "https://bandcamp.com/EmbeddedPlayer/album=2902099250/size=large/bgcol=333333/linkcol=ffffff/transparent=true/",
    link: "https://pruflaborsonor.bandcamp.com/album/pebbles-cove",
    label: "Pebble's Cove by Prüflabor Sonor",
    release: "2019-12-19",
    style: {
      width: "350px",
      height: "654px",
      border: "0"
    }
  },
];

module.exports = {
  BandCampIframes,
};
